import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "entry-node" }

import { Handle, Position } from "@vue-flow/core";

export default /*@__PURE__*/_defineComponent({
  __name: 'Entry',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "entry-icon" }, "▶", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("span", null, "开始", -1)),
    _createVNode(_unref(Handle), {
      id: "next",
      type: "source",
      position: _unref(Position).Right
    }, null, 8, ["position"])
  ]))
}
}

})